import { Component, Watch, Prop, Inject } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { FiltroParticipacion } from '@/shared/model/filtro-participacion.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';

import JhiDataUtils from '@/shared/data/data-utils.service';
import { Solucion } from '@/shared/model/solucion.model';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { Solicitud } from '@/shared/model/solicitud.model';
import ParticipanteService from '@/components/participantes/participante.service';
import { IFiltro } from '@/shared/model/filtro.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import CupoProgramaService from '@/entities/snp/administracion/cupo-programa.service';
import { EstadoBeca } from '@/shared/model/enumerations/estado-beca.model';

@Component
export default class MatriculaRegistroComponent extends mixins(JhiDataUtils, ApeironComponent) {
  @Inject('solicitudService') public solicitudService: () => SolicitudService;
  @Inject('participanteService') public participanteService: () => ParticipanteService;
  @Inject('cupoProgramaService') private readonly cupoProgramaService: () => CupoProgramaService;

  form = { subSeccion: null };
  filtro = new FiltroParticipacion();

  contenedorId = null;
  showNoProgramSelectedMessage = false;
  showNoInstitucionesMessage = false;
  showNoCupoProgramaMessage = false;
  showNoCupoInstitucionMessage = false;
  showNoSedesMessage = false;
  isSedeDuplicated = false;
  participantesKey = 0;
  institucionSelected = null;
  sedeSelected = null;
  dependenciaSelected = null;
  clavePrograma = null;
  public readonly ROL = RolAutoridad.ALUMNO;
  public tipoBeca = 'POSTULANTE_BECA';

  @Prop({ required: false })
  public solucion: Solucion;

  @Prop({ required: false })
  public solicitud: Solicitud;
  public matOcupada = 0;
  public matTotal = 0;

  public matOcupadaProg = 0;
  public matTotalProg = 0;

  public ocultaCupoPrograma = true;

  get showParticipantes() {
    return this.sedeSelected !== null;
  }

  created() {
    if (this.formModel?.subSeccion) {
      this.form.subSeccion = { ...this.form.subSeccion, ...JSON.parse(JSON.stringify(this.formModel.subSeccion)) };
    }
    this.clavePrograma = this.formModel.programa.clave;
    this.getCupoPrograma();
  }

  get instituciones() {
    if (this.formModel?.programa?.instituciones) {
      return this.formModel.programa.instituciones.map(institucion => {
        return { value: institucion, text: institucion.nombreInstitucion };
      });
    } else {
      this.showNoInstitucionesMessage = true;
      return [];
    }
  }

  get duracionOficial() {
    if (this.formModel?.programa?.planDeEstudios?.duracionOficial) {
      return this.formModel?.programa?.planDeEstudios?.duracionOficial;
    } else {
      return 0;
    }
  }

  get sedes() {
    if (this.institucionSelected?.sedes) {
      return this.institucionSelected?.sedes.map(sede => {
        return { value: sede, html: sede.sede + ' - ' + sede.nombreDependencia };
      });
    } else {
      this.showNoSedesMessage = true;
      return [];
    }
  }

  get isEditable() {
    return !this.readOnly;
  }

  public handleChangeInstitucionId(data) {
    this.sedeSelected = null;
    this.showNoSedesMessage = false;
    this.getCupoInstitucion();
  }
  public handleChangeSedeId(data) {
    this.contenedorId = this.institucionSelected.claveInstitucion + '-' + this.sedeSelected.claveSede;
    this.dependenciaSelected = this.sedeSelected;
    this.isSedeDuplicated = this.IsDuplicatedCurrentSede(this.sedeSelected.claveSede);
    this.participantesKey += 1;
  }

  public IsDuplicatedCurrentSede(currentClaveId) {
    const sedesFiltered = this.institucionSelected.sedes.filter(sede => sede.claveSede === currentClaveId);
    return sedesFiltered.length > 1;
  }

  /**
   * Cuando se selecciona una institución, se actualiza el contador de cupo disponible
   */
  public getCupoInstitucion(): void {
    this.matOcupada = 0;

    this.solicitudService()
      .contarCuposDeInstitucion(this.solucion?.id ?? '***', this.institucionSelected?.claveInstitucion)
      .then(totalCuposOcupados => {
        this.matOcupada = totalCuposOcupados;
      })
      .catch(error => {
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      });

    this.cupoProgramaService()
      .getCountInstitucion(this.solucion?.id, this.institucionSelected?.claveInstitucion)
      .then(res => {
        this.matTotal = parseInt(res.totalCupo);
        this.ocultaCupoPrograma = false;

        if (!this.matTotal) {
          this.showNoCupoInstitucionMessage = true;
          this.ocultaCupoPrograma = true;
        }
      })
      .catch(() => {
        this.ocultaCupoPrograma = true;
        this.alertService().showError(this, this.$t('apeironGwApp.programa.alert.errorInstitucion', 'Falla').toString());
      });
  }

  /**
   * Cuando se entra a la pantalla de matrícula, se actualiza el contador de cupo para el programa
   */
  public getCupoPrograma(): void {
    this.matOcupadaProg = 0;

    this.solicitudService()
      .contarCuposDePrograma(this.solucion?.id ?? '***', this.formModel.programa.clave)
      .then(totalCuposOcupados => {
        this.matOcupadaProg = totalCuposOcupados;
      })
      .catch(error => {
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      });

    this.cupoProgramaService()
      .getProgramaByClavePrograma(this.solucion?.id ?? '****', this.formModel.programa.clave)
      .then(res => {
        this.matTotalProg = parseInt(res.totalCupo ?? '0');

        if (!this.matTotalProg) {
          this.showNoCupoProgramaMessage = true;
        }
      })
      .catch(() => {
        this.alertService().showError(this, this.$t('apeironGwApp.programa.alert.errorInstitucion', 'Falla').toString());
        this.showNoCupoInstitucionMessage = true;
        this.showNoInstitucionesMessage = true;
      });
  }

  /**
   * Calcula la cantidad de matricula disponible para el programa seleccionado
   */
  public get matDisponibleProg() {
    return this.matTotalProg - this.matOcupadaProg;
  }

  /**
   * Calcula la cantidad de matricula disponible para la institucion seleccionada
   */
  public get matDisponible() {
    return this.matTotal - this.matOcupada;
  }

  /**
   * Actualiza los contadores de cupo para la institución y el programa
   */
  public actualizarContadoresCupo() {
    this.getCupoPrograma();
    this.getCupoInstitucion();
  }

  /**
   * Si la matrícula configurada para el programa es menor a 0, no se muestra el contador
   */
  get mostrarContadorPrograma() {
    if (this.matTotalProg < 0 || this.showNoCupoProgramaMessage) {
      return false;
    }
    return true;
  }

  /**
   * Si no hay configurado cupo por institución
   */
  get mostrarContadorInstitucion() {
    if (this.showNoCupoInstitucionMessage) {
      return false;
    }
    return true;
  }

  /**
   * Valida permisos para registrar nuevas matrículas
   */
  get permiteRegistrarMatricula(): boolean {
    return this.matDisponibleProg > 0 && this.matDisponible > 0;
  }
}
